import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
  createHashRouter,
} from "react-router-dom";
import "./App.css";
import Layout from "./Components/Layout/Layout";
import Home from "./Components/Home/Home";
import Categories from "./Components/Categories/Categories";
import Products from "./Components/Products/Products";
import Cart from "./Components/Cart/Cart";
import NotFound from "./Components/NotFound/NotFound";
import Login from "./Components/Login/Login";
import Register from "./Components/Register/Register";
import Brands from "./Components/Brands/Brands";
import Orders from "./Components/Orders/Orders";
import Address from "./Components/Address/Address";
import AuthContxtProvider from "./Components/AuthContext";
import ProtectedRoute from "./Components/ProtectedRoute";
import AuthProtectedRoute from "./Components/AuthProtectedRoute";
import ProductDetails from "./Components/ProductDetails/ProductDetails";
import { ToastContainer } from "react-toastify";
import CartcontextProvider from "./Components/Cartcontext";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

import WishList from "./Components/WishList/WishList";
import { WishlistProvider } from "./Components/WishContext";
import ForgetPassword from "./Components/ForgetPassword";
import VerfiyCode from "./Components/VerfiyCode";
import ResetPass from "./Components/ResetPass";


function App() {
  const queryClient = new QueryClient();
  const routers = createHashRouter([
    {
      path: "",
      element: <Layout />,
      children: [
        { path: "", element: <Navigate to={"home"} /> },
        {
          path: "login",
          element: (
            <AuthProtectedRoute>
              {" "}
              <Login />{" "}
            </AuthProtectedRoute>
          ),
        },
        {
          path: "register",
          element: (
            <AuthProtectedRoute>
              {" "}
              <Register />{" "}
            </AuthProtectedRoute>
          ),
        },
        { path: "ForgetPassword", element: <ForgetPassword /> },
        { path: "verify-code", element: <VerfiyCode /> },
        { path: "reset-password", element: <ResetPass /> },

        { path: "*", element: <NotFound /> },
        {
          path: "home",
          element: (
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          ),
        },

        {
          path: "categories",
          element: (
            <ProtectedRoute>
              <Categories />
            </ProtectedRoute>
          ),
        },
        {
          path: "Products",
          element: (
            <ProtectedRoute>
              {" "}
              <Products />
            </ProtectedRoute>
          ),
        },
        {
          path: "cart",
          element: (
            <ProtectedRoute>
              <Cart />
            </ProtectedRoute>
          ),
        },
        {
          path: "allorders",
          element: (
            <ProtectedRoute>
              {" "}
              <Orders />
            </ProtectedRoute>
          ),
        },
        {
          path: "address/:cartId",
          element: (
            <ProtectedRoute>
              <Address />
            </ProtectedRoute>
          ),
        },
        {
          path: "brands",
          element: (
            <ProtectedRoute>
              <Brands />
            </ProtectedRoute>
          ),
        },
        {
          path: "wishlist",
          element: (
            <ProtectedRoute>
              <WishList />
            </ProtectedRoute>
          ),
        },

        {
          path: "productdetails/:id",
          element: (
            <ProtectedRoute>
              <ProductDetails />
            </ProtectedRoute>
          ),
        },
      ],
    },
  ]);

  return (
    <>
        <QueryClientProvider client={queryClient}>
          <AuthContxtProvider>
            <CartcontextProvider>
              <WishlistProvider>
                <RouterProvider router={routers}></RouterProvider>
              </WishlistProvider>
            </CartcontextProvider>
          </AuthContxtProvider>
          <ReactQueryDevtools />
        </QueryClientProvider>
      <ToastContainer />
    </>
  );
}

export default App;
